import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

interface FilterSectionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  forceOpen?: boolean;
}

export function FilterSection({ title, children, defaultOpen = true, forceOpen }: FilterSectionProps) {
  return (
    <Disclosure defaultOpen={forceOpen ?? defaultOpen}>
      {({ open }) => (
        <div className="border-b border-gray-100 pb-3">
          <Disclosure.Button className="flex justify-between w-full py-2 text-left focus:outline-none" data-title={title}>
            <span className="text-sm font-medium tracking-tight text-gray-900">{title}</span>
            <ChevronUpIcon className={`${open ? 'transform rotate-180' : ''} w-4 h-4 text-gray-500`} />
          </Disclosure.Button>
          <Disclosure.Panel className="pt-2 font-light">
            {children}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
} 